var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container-row" },
    [
      _vm.loading
        ? _c("el-skeleton", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: true,
                expression: "true",
              },
            ],
            staticClass: "w-full h-full",
          })
        : _c("div", [
            _c("div", { staticClass: "main-content" }, [
              _c("div", { staticClass: "left-content flex-1" }, [
                _c("div", { staticClass: "kp-common-title my-10" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.getUser.userType === "1"
                          ? _vm.$t("client_home.kpTitle")
                          : _vm.$t("client_home.clientTitle")
                      ) +
                      "\n            "
                  ),
                ]),
                _vm.menuCodeList.includes("client001")
                  ? _c(
                      "div",
                      { staticClass: "pbc-container" },
                      [
                        _c(
                          "card-title",
                          {
                            attrs: {
                              title: _vm.$t("client_home.pbcItem"),
                              clickable: _vm.menuCodeList.includes("client001"),
                            },
                            on: {
                              toDashboard: function ($event) {
                                return _vm.toItemDashboard("pbc", "client001")
                              },
                            },
                          },
                          [
                            _vm.menuCodeList.includes("client001")
                              ? _c(
                                  "template",
                                  { slot: "select" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "home-select",
                                        on: {
                                          change: function ($event) {
                                            return _vm.queryHomePageAllPbcNum(
                                              "search"
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.pbcFilter,
                                          callback: function ($$v) {
                                            _vm.pbcFilter = $$v
                                          },
                                          expression: "pbcFilter",
                                        },
                                      },
                                      _vm._l(_vm.pbcOptions, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "flex mt-15" },
                          [
                            _vm._l(_vm.pbcItems, function (item) {
                              return [
                                _c("card-item", {
                                  staticClass: "pbc-item",
                                  attrs: {
                                    itemName: item.itemName,
                                    iconName: item.iconName,
                                    itemNumber: item.itemNumber,
                                    href: "pbc",
                                    status: item.status,
                                    hasAuth:
                                      _vm.menuCodeList.includes("client001"),
                                  },
                                  on: {
                                    toFilterList: function ($event) {
                                      return _vm.toFilterList(
                                        "pbc",
                                        item.status,
                                        "client001"
                                      )
                                    },
                                  },
                                }),
                              ]
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "flex" }, [
                  _vm.menuCodeList.includes("client006")
                    ? _c(
                        "div",
                        {
                          staticClass: "confirmation-container flex-1",
                          class: {
                            "mr-20": _vm.menuCodeList.includes("client003"),
                          },
                        },
                        [
                          _c("card-title", {
                            attrs: {
                              title: _vm.$t("client_home.confirmationItem"),
                              clickable: _vm.menuCodeList.includes("client006"),
                            },
                            on: {
                              toDashboard: function ($event) {
                                return _vm.toItemDashboard(
                                  "confirmation",
                                  "client006"
                                )
                              },
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "flex",
                              class: [
                                _vm.menuCodeList.includes("client003")
                                  ? "flex-col"
                                  : "flex-row",
                              ],
                            },
                            [
                              _vm._l(_vm.confirmationItems, function (item) {
                                return [
                                  _c("card-item", {
                                    staticClass: "confirmation-item",
                                    class: {
                                      "flex-1":
                                        !_vm.menuCodeList.includes("client003"),
                                      "mr-15":
                                        !_vm.menuCodeList.includes("client003"),
                                    },
                                    attrs: {
                                      itemName: item.itemName,
                                      iconName: item.iconName,
                                      itemNumber: item.itemNumber,
                                      numMiddle: false,
                                      status: item.status,
                                      hasAuth:
                                        _vm.menuCodeList.includes("client006"),
                                    },
                                    on: {
                                      toFilterList: function ($event) {
                                        return _vm.toFilterList(
                                          "confirmation",
                                          item.status,
                                          "client006"
                                        )
                                      },
                                    },
                                  }),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.menuCodeList.includes("client003")
                    ? _c(
                        "div",
                        { staticClass: "mattersLog-container" },
                        [
                          _c(
                            "card-title",
                            {
                              attrs: {
                                title: _vm.$t("client_home.mattersLogItem"),
                                clickable:
                                  _vm.menuCodeList.includes("client003"),
                              },
                              on: {
                                toDashboard: function ($event) {
                                  return _vm.toItemDashboard(
                                    "matterLogs",
                                    "client003"
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "select" },
                                [
                                  _vm.menuCodeList.includes("client003")
                                    ? _c(
                                        "el-select",
                                        {
                                          staticClass: "home-select",
                                          on: {
                                            change: function ($event) {
                                              return _vm.queryMatterInfo(
                                                "search"
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.mattersLogFilter,
                                            callback: function ($$v) {
                                              _vm.mattersLogFilter = $$v
                                            },
                                            expression: "mattersLogFilter",
                                          },
                                        },
                                        _vm._l(_vm.pbcOptions, function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }),
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex justify-center border-normal mt-10",
                            },
                            [
                              _vm._l(_vm.mattersLogItems, function (item) {
                                return [
                                  _c("card-item", {
                                    staticClass: "mattersLog-item",
                                    class: {
                                      "mattersLog-item-single":
                                        !_vm.menuCodeList.includes("client006"),
                                    },
                                    attrs: {
                                      itemName: item.itemName,
                                      iconName: item.iconName,
                                      itemNumber: item.itemNumber,
                                      href: "confirmation",
                                      status: item.status,
                                      hasAuth:
                                        _vm.menuCodeList.includes("client003"),
                                      numMiddle:
                                        _vm.menuCodeList.includes("client006"),
                                    },
                                    on: {
                                      toFilterList: function ($event) {
                                        return _vm.toFilterList(
                                          "matterLogs",
                                          item.status,
                                          "client003"
                                        )
                                      },
                                    },
                                  }),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm.menuCodeList.includes("client002")
                  ? _c(
                      "div",
                      { staticClass: "statutory-container" },
                      [
                        _c("card-title", {
                          attrs: {
                            title: _vm.$t("client_home.accountsOverview"),
                            clickable: _vm.menuCodeList.includes("client002"),
                          },
                          on: {
                            toDashboard: function ($event) {
                              return _vm.toItemDashboard(
                                "accounts",
                                "client002"
                              )
                            },
                          },
                        }),
                        _c("hr", { staticClass: "line-split" }),
                        _c("executive-dashboard"),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "right-content-container" }, [
                _c(
                  "div",
                  { staticClass: "kp-common-title my-10 flex justify-between" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("client_home.workspace")) +
                        "\n                "
                    ),
                    _c(
                      "div",
                      {
                        class:
                          _vm.updateGuide && _vm.updateGuideStep === 2 && false
                            ? "updateGuideBtn"
                            : "",
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "wl-green svg-btn",
                            on: { click: _vm.showClientDownload },
                          },
                          [
                            _c("img", {
                              staticClass: "btn-icon",
                              attrs: {
                                src: require("@/assets/img/icon-statisticaldata.svg"),
                                width: "100%",
                              },
                            }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("site007")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm.getUser.userType === "1" && _vm.isShowWaring
                          ? _c("i", {
                              staticClass: "el-icon-warning waring-icon",
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
                _vm.updateGuide &&
                (_vm.updateGuideStep === 1 || _vm.clientAdminNoticeFlag)
                  ? _c("div", { staticClass: "updateGuide" })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "right-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "wl-client-container kpmg" },
                      [
                        _vm._l(_vm.menu, function (item, index) {
                          return [
                            _vm.getShowMenuCodeList.indexOf(item.menuCode) !==
                            -1
                              ? _c(
                                  "div",
                                  {
                                    key: item.key,
                                    staticClass: "border-normal",
                                    class: _vm.getBgClassName(item.menuCode),
                                    on: {
                                      click: function ($event) {
                                        return _vm.goDetail(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm.updateGuide &&
                                    _vm.updateGuideStep === 1 &&
                                    item.menuCode === "client004"
                                      ? _c(
                                          "div",
                                          { staticClass: "updateGuideTip" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "margin-bottom-10",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "KPMGExecutiveEducation"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "guide-btn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.gotItClick({
                                                      homeNoticeReadFlag: 1,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(_vm.$t("gotIt")))]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.updateGuide &&
                                    _vm.clientAdminNoticeFlag &&
                                    item.menuCode === "client008"
                                      ? _c(
                                          "div",
                                          { staticClass: "updateGuideTip" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "margin-bottom-10",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("newFapiaoTip"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "guide-btn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.gotItClick({
                                                      clientAdminNoticeFlag: 1,
                                                    })
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(_vm.$t("gotIt")))]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.menuCode === "client006" && false
                                      ? _c("div", {
                                          class: ["icon-new", _vm.iconNew],
                                        })
                                      : _vm._e(),
                                    item.menuCode === "client005" && false
                                      ? _c("div", {
                                          class: ["icon-new", _vm.iconNew],
                                        })
                                      : _vm._e(),
                                    item.menuCode === "client008"
                                      ? _c("div", {
                                          class: ["icon-new", _vm.iconNew],
                                        })
                                      : _vm._e(),
                                    item.menuCode === "client004" && false
                                      ? _c("div", {
                                          class: ["icon-new", _vm.iconNewSAS],
                                        })
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "menu_item_info" },
                                      [
                                        item.menuCode === "client001"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/client-icon01.png"),
                                              },
                                            })
                                          : _vm._e(),
                                        item.menuCode === "client005"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/client-icon02.png"),
                                              },
                                            })
                                          : _vm._e(),
                                        item.menuCode === "client002"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/client-icon03.png"),
                                              },
                                            })
                                          : _vm._e(),
                                        item.menuCode === "client003"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/client-icon04.png"),
                                              },
                                            })
                                          : _vm._e(),
                                        item.menuCode === "client004"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/client-icon05.png"),
                                              },
                                            })
                                          : _vm._e(),
                                        item.menuCode === "client006"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/client-icon06.png"),
                                              },
                                            })
                                          : _vm._e(),
                                        item.menuCode === "client007"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/client-icon07.png"),
                                              },
                                            })
                                          : _vm._e(),
                                        item.menuCode === "client008"
                                          ? _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/client-icon08.png"),
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              "menu",
                                              _vm.$i18n.locale === "en"
                                                ? "en-fontSize"
                                                : "",
                                            ],
                                            style:
                                              "color: " +
                                              _vm.getFontColor(item.menuCode),
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(_vm.$t(item.menuCode)) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: _vm.getCoverBgClassName(
                                          item.menuCode
                                        ),
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              "vertical",
                                              _vm.$i18n.locale === "en"
                                                ? "en-cover-fontSize"
                                                : "",
                                              `cover-${_vm.$i18n.locale}-${item.menuCode}`,
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$t(item.menuCode + "_des")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                    _c("hr", { staticClass: "line-split" }),
                    _c("right-baseItem", {
                      attrs: {
                        "item-name": _vm.$t("client_home.clientContact"),
                        type: "contact",
                        "icon-name": "kpContact",
                      },
                    }),
                    _c("right-baseItem", {
                      attrs: {
                        "item-name": _vm.$t("client_home.recommendTitle"),
                        type: "speed",
                        "icon-name": "kpSpeed",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.clientDownloadVis,
            direction: "rtl",
            size: "80%",
            "before-close": _vm.handleClientDownloadClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.clientDownloadVis = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "wl-info", attrs: { slot: "title" }, slot: "title" },
            [
              _c("div", { staticClass: "wl-info-title" }, [
                _vm._v(_vm._s(_vm.$t("site007"))),
              ]),
              _vm.getUser.userType === "1"
                ? _c(
                    "div",
                    { staticClass: "column-btn", on: { click: _vm.setClick } },
                    [
                      _c("img", {
                        staticClass: "table-setting-icon",
                        attrs: {
                          src: require("@/assets/img/icon-setting1.svg"),
                          width: "100%",
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("alter_setting")))]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _c("el-row", { staticClass: "search-row" }, [
            _c(
              "div",
              { staticClass: "el-col-12 el-row--flex" },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "line-height": "30px",
                      "margin-right": "5px",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("downloaded_date")) + ": ")]
                ),
                _c("el-date-picker", {
                  staticClass: "wl-item wl-date-item2 input-with-select margin",
                  attrs: {
                    "picker-options": _vm.pickerOptions,
                    type: "daterange",
                    "value-format": "yyyy-MM-dd",
                    "range-separator": "~",
                    "start-placeholder": _vm.$t("begin_date"),
                    "end-placeholder": _vm.$t("end_date"),
                    "popper-class": [
                      this.$i18n.locale === "en" ? "date-search-popper" : "",
                    ],
                  },
                  on: { blur: _vm.searchBtnClick },
                  model: {
                    value: _vm.datePickerVal,
                    callback: function ($$v) {
                      _vm.datePickerVal = $$v
                    },
                    expression: "datePickerVal",
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    attrs: { icon: "el-icon-search" },
                    on: { click: _vm.searchBtnClick },
                  },
                  [_vm._v(_vm._s(_vm.$t("btn_search2")) + " ")]
                ),
                _c(
                  "el-button",
                  { staticClass: "cancel-btn", on: { click: _vm.clearAll } },
                  [_vm._v(_vm._s(_vm.$t("COMMON_CLEAR_BTN")) + " ")]
                ),
              ],
              1
            ),
            _vm.getUser.userType === "1"
              ? _c(
                  "div",
                  { staticClass: "el-col-12" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "wl-green right",
                        on: { click: _vm.exportBtnClick },
                      },
                      [
                        _c("img", {
                          staticClass: "btn-icon",
                          attrs: {
                            src: require("@/assets/img/icon-export.svg"),
                            width: "100%",
                            alt: "",
                          },
                        }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("export_downloaded_files_list")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "table-container-wrapper" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  attrs: {
                    height: "100%",
                    data: _vm.tableData,
                    stripe: "",
                    border: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "#",
                      type: "index",
                      "header-align": "center",
                      align: "center",
                      width: "60",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "clientUserName",
                      "header-align": "center",
                      align: "left",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("client_list_user_name")) +
                                "\n                        "
                            ),
                            _c(
                              "el-popover",
                              {
                                ref: "trackNumPopper1",
                                staticStyle: { display: "inline-block" },
                                attrs: { placement: "bottom" },
                                on: { hide: _vm.searchBtnClick },
                                scopedSlots: _vm._u([
                                  {
                                    key: "reference",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter-down" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-arrow-down",
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              },
                              [
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-input" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.clientUserNameVal,
                                          callback: function ($$v) {
                                            _vm.clientUserNameVal = $$v
                                          },
                                          expression: "clientUserNameVal",
                                        },
                                      }),
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.clientUserNameVal.length > 0,
                                            expression:
                                              "clientUserNameVal.length > 0",
                                          },
                                        ],
                                        staticClass:
                                          "el-icon-circle-close clear-btn",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            _vm.clientUserNameVal = ""
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "header-btn-position" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "wl-green",
                                          on: {
                                            click: function ($event) {
                                              return _vm.filterClientUserName(
                                                _vm.clientUserNameVal
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("btn_search2")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                              ],
                              2
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "email",
                      "header-align": "center",
                      align: "left",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("client_list_client_email")) +
                                "\n                        "
                            ),
                            _c(
                              "el-popover",
                              {
                                ref: "trackNumPopper2",
                                staticStyle: { display: "inline-block" },
                                attrs: { placement: "bottom" },
                                on: { hide: _vm.searchBtnClick },
                                scopedSlots: _vm._u([
                                  {
                                    key: "reference",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "th-filter-down" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-arrow-down",
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              },
                              [
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-input" },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value: _vm.emailVal,
                                          callback: function ($$v) {
                                            _vm.emailVal = $$v
                                          },
                                          expression: "emailVal",
                                        },
                                      }),
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.emailVal.length > 0,
                                            expression: "emailVal.length > 0",
                                          },
                                        ],
                                        staticClass:
                                          "el-icon-circle-close clear-btn",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            _vm.emailVal = ""
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "header-btn-position" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "wl-green",
                                          on: {
                                            click: function ($event) {
                                              return _vm.filterEmailVal(
                                                _vm.emailVal
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("btn_search2")))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                              ],
                              2
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "PBC",
                        prop: "PBC",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("businesshome_right_row1_title_pcs"),
                          prop: "pbcPcs",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "businesshome_right_row1_title_pcs"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort("pbcPcs")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.pbcPcs === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.pbcPcs === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("size"),
                          prop: "pbcSize",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(_vm._s(_vm.$t("size"))),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort("pbcSize")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.pbcSize === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.pbcSize === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("fileSize")(scope.row.pbcSize)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("config_joint_title"),
                        prop: "jointWorking",
                        "header-align": "center",
                        align: "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("businesshome_right_row1_title_pcs"),
                          prop: "jointWorkingPcs",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "businesshome_right_row1_title_pcs"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort(
                                            "jointWorkingPcs"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.jointWorkingPcs === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.jointWorkingPcs === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("size"),
                          prop: "jointWorkingSize",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(_vm._s(_vm.$t("size"))),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort(
                                            "jointWorkingSize"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.jointWorkingSize === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.jointWorkingSize === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("fileSize")(
                                        scope.row.jointWorkingSize
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("client002"),
                        prop: "statutory",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("businesshome_right_row1_title_pcs"),
                          prop: "statutoryPcs",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "businesshome_right_row1_title_pcs"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort("statutoryPcs")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.statutoryPcs === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.statutoryPcs === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("size"),
                          prop: "statutorySize",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(_vm._s(_vm.$t("size"))),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort("statutorySize")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.statutorySize === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.statutorySize === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("fileSize")(
                                        scope.row.statutorySize
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("client003"),
                        prop: "matterLog",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("businesshome_right_row1_title_pcs"),
                          prop: "matterLogPcs",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "businesshome_right_row1_title_pcs"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort("matterLogPcs")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.matterLogPcs === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.matterLogPcs === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("size"),
                          prop: "matterLogSize",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(_vm._s(_vm.$t("size"))),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort("matterLogSize")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.matterLogSize === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.matterLogSize === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("fileSize")(
                                        scope.row.matterLogSize
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("config_confirmation"),
                        prop: "confirmation",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("businesshome_right_row1_title_pcs"),
                          prop: "confirmationPcs",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "businesshome_right_row1_title_pcs"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort(
                                            "confirmationPcs"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.confirmationPcs === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.confirmationPcs === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("size"),
                          prop: "confirmationSize",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(_vm._s(_vm.$t("size"))),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort(
                                            "confirmationSize"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.confirmationSize === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.confirmationSize === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("fileSize")(
                                        scope.row.confirmationSize
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: _vm.$t("total_downloaded_files"),
                        prop: "totalDownloadedFiles",
                        "header-align": "center",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("businesshome_right_row1_title_pcs"),
                          prop: "totalPcs",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "businesshome_right_row1_title_pcs"
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort("totalPcs")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.totalPcs === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.totalPcs === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.getUser.userType === "1"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "underline-content",
                                        class: {
                                          waring: scope.row.totalPcsIsOver,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showDownloadFileClick(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(scope.row.totalPcs) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticStyle: { color: "#3879eb" } },
                                      [_vm._v(_vm._s(scope.row.totalPcs))]
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("size"),
                          prop: "totalSize",
                          "header-align": "center",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "th" }, [
                                  _c("div", { staticClass: "th-label" }, [
                                    _vm._v(_vm._s(_vm.$t("size"))),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "th-sort",
                                      on: {
                                        click: function ($event) {
                                          return _vm.switchSort("totalSize")
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-top th-sort-up",
                                        class: [
                                          _vm.sort.totalSize === "asc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-caret-bottom th-sort-down",
                                        class: [
                                          _vm.sort.totalSize === "desc"
                                            ? "th-sort-active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.getUser.userType === "1"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "underline-content",
                                        class: {
                                          waring: scope.row.totalSizeIsOver,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showDownloadFileClick(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("fileSize")(
                                                scope.row.totalSize
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticStyle: { color: "#3879eb" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("fileSize")(
                                              scope.row.totalSize
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-pagination", {
                staticClass: "wl-pagination",
                attrs: {
                  "current-page": _vm.pagination.pageNum,
                  "page-size": _vm.pagination.pageSize,
                  "page-sizes": [10, 50, 100],
                  layout: "prev, pager, next, sizes, total",
                  total: _vm.pagination.total,
                },
                on: {
                  "current-change": _vm.onCurrentPageChange,
                  "size-change": _vm.onSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("alter_setting"),
            width: "400px",
            visible: _vm.setVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.setVisible = $event
            },
            close: _vm.cancelClick,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "setForm",
              attrs: { model: _vm.setForm, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "bottom-line",
                  attrs: { label: _vm.$t("client_download_title_1") },
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.setForm.fileNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "fileNum", $$v)
                      },
                      expression: "setForm.fileNum",
                    },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("UNIT_02")) + "\n            "),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "bottom-line",
                  attrs: { label: _vm.$t("client_download_title_2") },
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.setForm.fileSize,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "fileSize", $$v)
                      },
                      expression: "setForm.fileSize",
                    },
                  }),
                  _vm._v(" MB\n            "),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-switch", {
                    staticClass: "switch-width-cls",
                    attrs: {
                      "active-color": "#409EFF",
                      "inactive-color": "#cccccc",
                    },
                    model: {
                      value: _vm.setForm.isSendEmailAlert,
                      callback: function ($$v) {
                        _vm.$set(_vm.setForm, "isSendEmailAlert", $$v)
                      },
                      expression: "setForm.isSendEmailAlert",
                    },
                  }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("PAGE_CLIENTUSER_EMAIL")) +
                      "\n                "
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#fd349c",
                        "word-break": "break-word",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-warning" }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("alert_engagement_manager")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "wl-gray",
                  attrs: { loading: _vm.dialogLoading },
                  on: { click: _vm.cancelClick },
                },
                [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: { loading: _vm.dialogLoading },
                  on: { click: _vm.saveClick },
                },
                [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("FILE_LIST_TITLE"),
            visible: _vm.showDownloadVis,
            "before-close": _vm.handleDownloadClose,
            width: "70%",
            top: "25vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDownloadVis = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.downloadFileLoading,
                  expression: "downloadFileLoading",
                },
              ],
              attrs: {
                data: _vm.gridData,
                "max-height": "400",
                stripe: "",
                size: "mini",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "uploadFilename",
                  label: _vm.$t("DOWNLOAD_FILE_NAME"),
                  width: "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "size", label: _vm.$t("DOWNLOAD_SIZE") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm._f("fileSize")(scope.row.size))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sourceType",
                  label: _vm.$t("kcc_tile"),
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.$t(_vm.tilesNameTrans(scope.row.sourceType))
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "uploadedName", label: _vm.$t("UPLOAD_BY") },
              }),
              _c("el-table-column", {
                attrs: { prop: "uploadedDate", label: _vm.$t("UPLOAD_TIME") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.dateFormat(
                                new Date(scope.row.uploadedDate),
                                "yyyy-MM-dd hh:mm:ss"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "downloadedName",
                  label: _vm.$t("FILE_DOWNLOAD_BY"),
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "downloadedDate",
                  label: _vm.$t("DOWNLOAD_TIME"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.dateFormat(
                                new Date(scope.row.downloadedDate),
                                "yyyy-MM-dd hh:mm:ss"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              "current-page": _vm.downloadPagination.pageNum,
              "page-size": _vm.downloadPagination.pageSize,
              "page-sizes": [10, 50, 100],
              layout: "prev, pager, next, sizes, total",
              total: _vm.downloadPagination.total,
            },
            on: {
              "current-change": _vm.downloadCurrentPageChange,
              "size-change": _vm.downloadSizeChange,
            },
          }),
        ],
        1
      ),
      _vm.authorisePopVisible
        ? _c("admin-authorise", {
            attrs: {
              onCancel: _vm.cancelAuthorisePop,
              onConfirm: _vm.confirmAuthorisePop,
              onNoConfirm: _vm.noAuthorisePop,
              activeStep: _vm.activeStep,
            },
          })
        : _vm._e(),
      _vm.pwdPopVisible
        ? _c("Pwd-complexity", {
            attrs: {
              onCancel: _vm.cancelPwdPop,
              onConfirm: _vm.confirmPwdPop,
              onNoConfirm: _vm.noPwdPop,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }